import { render, staticRenderFns } from "./migrapremium.vue?vue&type=template&id=0fe26e68&scoped=true"
import script from "./migrapremium.vue?vue&type=script&lang=js"
export * from "./migrapremium.vue?vue&type=script&lang=js"
import style0 from "./migrapremium.vue?vue&type=style&index=0&id=0fe26e68&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0fe26e68",
  null
  
)

export default component.exports